function uiSelectChoicesListenerDirective() {
    'ngInject';

    return function (scope, elm, attr) {
        scope.$on('UISelect:closeSelect', () => {
            return scope.$select.close();
        });
    };
}

export default uiSelectChoicesListenerDirective;

angular
    .module('BB.uiSelect')
    .directive('uiSelectChoicesListener', uiSelectChoicesListenerDirective);


// WEBPACK FOOTER //
// node_modules/bookingbug-angular/src/core/-ui-select/ui-select-choices-listener/ui_select_choices_listener.directive.js